// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box-layout .-rn-footer[data-v-173a3004]{background:#f9f9f9}.box-layout header.header.header-flat[data-v-173a3004]{padding:0}", ""]);
// Exports
module.exports = exports;
